<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-07 19:51:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-31 17:53:37
 * @FilePath: \partner.chaoyongtuan.com\src\views\sampleOrder\list\components\tableCell\tag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-popover placement="bottom" width="200" trigger="hover" :content="reason" :disabled="!isPopver">
		<div :class="['tag fz-12 nowrap radius-4', classStyle]" slot="reference">
			<span>{{ desc }}</span>
			<i class="el-icon-arrow-right" v-if="isPopver"></i>
		</div>
	</el-popover>
</template>
<script>
export default {
	props: {
		desc: {
			type: String,
			default: '',
		},
		reason: {
			type: String,
			default: '',
		},
		status: {
			type: [String, Number],
			default: '',
		},
	},
	computed: {
		classStyle({ status }) {
			const obj = {
				0: 'warning',
				1: 'warning',
				2: 'warning',
				3: 'defalut',
				4: 'success',
				5: 'error',
			};
			return obj[status];
		},
		isPopver({ status }) {
			const val = +status;
			return val === 5 || val === 0;
		},
	},
};
</script>
<style lang="less" scoped>
.tag {
	display: flex;
	align-items: center;
	padding: 0 4px;
	line-height: 16px;
}
.warning {
	border: 1px solid #ffe4ba;
	color: #f97a00;
}
.defalut {
	border: 1px solid #e2e3e8;
	color: @color-regular;
}
.success {
	border: 1px solid #cff1d2;
	color: @color-g;
}
.error {
	border: 1px solid #fed4d0;
	color: @color-error;
}
</style>
